




































































































import 'bootstrap';
import bootbox from 'bootbox';
import {Component, Vue, Prop} from 'vue-property-decorator';
import {StudentProfile} from '@/classes/StudentProfile';
import {dateFormatter} from '@/services/inputTools';
import JobCorpsCenter from '@/classes/JobCorpsCenter';
import router from '@/router';
import {sprintf} from 'sprintf-js';
import UserProfile from '@/classes/UserProfile';
import authorize, {Office} from '@/services/Authorize';


@Component({
    filters: {
        dateFormatter
    }
})
export default class StudentEditView extends Vue {

    @Prop() private id!: number;

    private eProfile?: StudentProfile;

    private saving: boolean = false;

    private studentActive: boolean = false;

    get editProfile(): StudentProfile {
        if (null == this.eProfile) {
            this.eProfile = this.currentProfile.clone();
            this.studentActive = !!this.eProfile.active;
        }

        return this.eProfile;
    }

    get currentProfile(): StudentProfile {
        return this.$store.getters['students/getStudentById'](this.id);
    }

    get jobCorpsCenters(): JobCorpsCenter[] {
        return this.$store.getters.getJobCorpsCentersAllowed;
    }

    get canEdit(): boolean {
        if (authorize(Office)) {
            return true;
        } else {
            let canEdit = true;
            if (this.currentProfile !== undefined && this.currentProfile.jobCorpsCenterId !== undefined) {
                canEdit =  this.allowedCenters.includes(this.currentProfile.jobCorpsCenterId);
            }
            return canEdit;
        }
    }
    get allowedCenters(): number[] {
        return this.$store.getters.getActiveProfile ? this.$store.getters.getActiveProfile.jobCorpsCenterIds : [];
    }

    private saveChanges() {

        this.editProfile.active = this.studentActive;

        this.saving = true;

        this.$store.dispatch('students/saveStudent', this.editProfile)
            .then(()  => {
                router.push(sprintf('/students/profile/%d', this.currentProfile.id));
            })
            .catch((err) => {
                // TODO: handle this error better.
                bootbox.alert(err.message);
            })
            .finally(() => {
                this.saving = false;
            });
    }
}


